import { FormControl, FormHelperText, InputLabel, Select, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export const RHFSelect = ({ name, children, label, ...other }) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControl fullWidth variant="outlined" error={!!error}>
            <InputLabel id="demo-simple-select-helper-label">{label}</InputLabel>
            <Select {...field} label={label} value={field.value} {...other}>
              {children}
            </Select>
            <FormHelperText>{error?.message}</FormHelperText>
          </FormControl>
        </>
      )}
    />
  );
};
